/* eslint-disable import-helpers/order-imports */
import React from 'react';

import GenericCard from '@submodules/GenericCard';
import GlobalRichText from '@submodules/GlobalRichText';
import Hero from '@sections/Hero';
import ContainerTable from '@sections/ContainerTable';

type SubModuleProps = {
  __typename: string,
  contentful_id: string,
};

type SubModuleSelectorProps = {
  submodules: SubModuleProps[];
};

const SubModuleSelector = ({
  submodules,
}: SubModuleSelectorProps): JSX.Element => {
  if(submodules){
    return (
      <>
        {
          submodules.map((submodule: SubModuleProps, index: number) => {
            const key = `${submodule?.contentful_id}-${index}`;
            // eslint-disable-next-line no-underscore-dangle
            switch (submodule.__typename) {
              case 'ContentfulGenericCard':
                return (
                  <GenericCard
                    key={key}
                    item={submodule}
                  />
                );
              case 'ContentfulRichText':
                return (
                  <GlobalRichText
                    key={key}
                    item={submodule}
                  />
                );
              case 'ContentfulHero':
                return (
                  <Hero 
                    key={key} 
                    item={submodule} 
                  />
                );
              case 'ContentfulContainerTable':
                return (
                  <ContainerTable 
                    key={key} 
                    item={submodule} 
                  />
                );
              default:
                return <React.Fragment key={key} />;
            }
          })
        }
      </>
    );
  }
  return <></>;
};

export default SubModuleSelector;
